"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localeCompareByTitle = void 0;
const localeCompareByTitle = (a, b) => {
  const firstTitle = a.title;
  const secondTitle = b.title;
  return firstTitle.localeCompare(secondTitle);
};
exports.localeCompareByTitle = localeCompareByTitle;
//# sourceMappingURL=sortingHelpers.js.map